<div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-xl">
  <div>
    <h1 class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface mb-1">Technician Inventory</h1>
    @if (error()) {
      <p class="text-error font-body-sm text-body-sm">{{ error() }}</p>
    }
  </div>
</div>

@if (authService.isAdmin()) {
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-md flex items-center gap-3 mb-gutter shadow-sm">
    <label class="flex flex-col gap-1">
      <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Viewing</span>
      <select [value]="selectedTechnicianId() ?? ''" (change)="onTechnicianChange($any($event.target).value)"
              class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm h-[48px] text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] min-w-[220px]">
        <option value="">Select technician...</option>
        @for (tech of technicians(); track tech.technicianId) {
          <option [value]="tech.technicianId">{{ tech.firstName }} {{ tech.lastName }}</option>
        }
      </select>
    </label>
    @if (matchedOwnTechnician()) {
      <span class="text-xs text-[#8DC63F] flex items-center gap-1 mt-5">
        <span class="material-symbols-outlined text-[16px]">check_circle</span>
        Matched to your signed-in account
      </span>
    }
  </div>
} @else if (matchedOwnTechnician()) {
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-md flex items-center gap-2 mb-gutter shadow-sm">
    <span class="material-symbols-outlined text-[#8DC63F] text-[20px]">check_circle</span>
    <p class="font-label-md text-text-main dark:text-on-surface">Your inventory, {{ ownTechnicianName() }}</p>
  </div>
}

@if (!authService.isAdmin() && !matchedOwnTechnician()) {
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm shadow-sm">
    No technician profile is linked to your account yet. Ask an Admin to create one on the
    <a routerLink="/technicians" class="text-[#00B9F2] hover:underline">Technicians page</a> using this email.
  </div>
} @else if (authService.isAdmin() && !selectedTechnicianId()) {
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm shadow-sm">
    Pick a technician above to view their inventory.
  </div>
} @else {
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl overflow-hidden shadow-sm">
    @if (loading()) {
      <p class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">Loading inventory...</p>
    } @else if (mode() === 'view') {
      <div class="p-lg border-b border-border-subtle dark:border-outline-variant flex items-center justify-between">
        <p class="font-label-md text-text-main dark:text-on-surface">Currently Carrying</p>
        @if (canEditSelected()) {
          <button type="button" (click)="startEdit()"
                  class="h-[40px] px-4 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-sm flex items-center gap-2">
            <span class="material-symbols-outlined text-[18px]">edit</span>
            Edit
          </button>
        }
      </div>

      @if (!hasAnyItems()) {
        <div class="p-8 text-center text-text-muted dark:text-on-surface-variant font-body-sm">
          <span class="material-symbols-outlined text-[32px] mb-2 inline-block">inventory_2</span>
          <p>No inventory reported yet.</p>
          @if (canEditSelected()) {
            <button type="button" (click)="startEdit()" class="mt-3 text-[#00B9F2] hover:underline font-label-sm">Get started</button>
          }
        </div>
      } @else {
        <div class="p-lg flex flex-col gap-5">
          @for (group of viewGroups(); track group.category) {
            <div>
              <p class="font-label-sm text-text-muted dark:text-on-surface-variant mb-2">{{ group.category }}</p>
              <div class="flex flex-wrap gap-2">
                @for (item of group.items; track item.itemId) {
                  <span class="inline-flex items-center gap-2 bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-full pl-3 pr-2 py-1">
                    <span class="font-body-sm text-text-main dark:text-on-surface">{{ item.name }}</span>
                    <span class="font-label-sm text-white bg-[#00B9F2] rounded-full w-6 h-6 flex items-center justify-center shrink-0 text-xs">{{ item.quantity }}</span>
                  </span>
                }
              </div>
            </div>
          }
        </div>
      }
    } @else {
      <div class="p-lg flex flex-col gap-6">
        @for (group of editGroups(); track group.category) {
          <div>
            <p class="font-label-md text-text-main dark:text-on-surface mb-3">{{ group.category }}</p>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              @for (item of group.items; track item.itemId) {
                <div class="flex items-center justify-between gap-3 bg-surface dark:bg-surface-container-highest rounded-lg px-3 py-2">
                  <span class="font-body-sm text-text-main dark:text-on-surface">{{ item.name }}</span>
                  <input type="number" min="0" [value]="item.quantity" (change)="updateQuantity(item.itemId, $any($event.target).value)"
                         class="w-16 shrink-0 bg-background dark:bg-surface-container border border-border-subtle dark:border-outline-variant rounded-md px-2 py-1 text-body-sm text-text-main dark:text-white text-right focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="p-lg border-t border-border-subtle dark:border-outline-variant flex items-center justify-between gap-3">
        @if (saveMessage()) {
          <p class="text-[#8DC63F] font-body-sm text-body-sm">{{ saveMessage() }}</p>
        } @else {
          <span></span>
        }
        <div class="flex items-center gap-3 shrink-0">
          <button type="button" (click)="cancelEdit()" [disabled]="saving()"
                  class="h-[44px] px-6 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-md disabled:opacity-50">
            Cancel
          </button>
          <button type="button" (click)="save()" [disabled]="saving()"
                  class="h-[44px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity font-label-md disabled:opacity-50">
            {{ saving() ? 'Saving...' : 'Save Inventory' }}
          </button>
        </div>
      </div>
    }
  </div>
}
